/**
 * Import the label-specific translation bundle using webpack's compile-time label constant.
 *
 * @param ln Active language code.
 * @returns Translation module promise, or an empty object when no override exists.
 */
export default function importCustomLanguage(ln: string): Promise<unknown> {
	return import(
		/* webpackChunkName: "translations" */
		`../i18n/${ln}/${LABEL}/custom.json`
	).catch((error: unknown) => {
		/** Only a missing optional context entry is harmless; failed chunks must still reject. */
		if (
			error instanceof Error
			&& 'code' in error
			&& error.code === 'MODULE_NOT_FOUND'
			&& error.message === `Cannot find module './${ln}/${LABEL}/custom.json'`
		) {
			return {};
		}

		throw error;
	});
}
